import { render, staticRenderFns } from "./SiteAbout.vue?vue&type=template&id=ad5a93c4&"
import script from "./SiteAbout.vue?vue&type=script&lang=js&"
export * from "./SiteAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports